import { createGlobalStyle } from 'styled-components';

export const GliaGlobalStyle = createGlobalStyle`
  #salemove .sm-visitor-app {
    display: none !important;

    @media (min-width: 1250px) {
      display: block !important;
    }
  }
`;
